// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/global.css';  // ← Global styles imported here

// ── Venue theme: apply brand color + saved theme before React renders ─────────
function hexToRgb(hex: string): [number, number, number] | null {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
}
function adjustBrightness(hex: string, amount: number): string {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  return '#' + rgb.map(c => Math.max(0, Math.min(255, c + amount)).toString(16).padStart(2, '0')).join('');
}
(function applyVenueTheme() {
  const color = (process.env.REACT_APP_VENUE_COLOR || '#FF6B35').trim();
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', color);
  root.style.setProperty('--brand-primary-dark', adjustBrightness(color, -40));
  const rgb = hexToRgb(color);
  if (rgb) root.style.setProperty('--brand-primary-light', `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.15)`);
  root.setAttribute('data-theme', localStorage.getItem('oni_dash_theme') || 'light');
})();
// ─────────────────────────────────────────────────────────────────────────────

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);